import { get as _get } from 'lodash'

export default class OrderLine {
  constructor (order_line) {
    this.product_id = _get(order_line, 'product.id') || _get(order_line, 'product_id')
    this.quantity = _get(order_line, 'total_ordered') || _get(order_line, 'added_quantity', 0) * -1 || _get(order_line, 'quantity')
  }
}
